// [수정된 파일: WormUp-main/src/components/Input/Input.js]
import React from 'react';

// [수정] value와 onChange prop을 받도록 변경
export function Input({ value, onChange }) { 
    return (
        <input 
            className="input-field" 
            type="text" 
            placeholder="닉네임을 입력하세요"
            value={value} // [추가] value 연결
            onChange={onChange} // [추가] onChange 연결
        />
    );
}

// ... (기존 Input.js의 다른 코드 유지)